export const MIN_LEN = 0;
export const FORM_LEN = 1;
export const JSON_STR_BASE = 2;

export const PHONE_VERIFICATION_BYPASS_ORG_ID = '';
export const PHONE_VERIFICATION_BYPASS_CODE = '123456';

// `GET /v1/commands/:id` vocabulary. cqrs SDB-730 (dev, 2026-08-12) collapses the
// internal CommandStatus values into a client-facing trio: PROCESSING / COMPLETED /
// FAILED. Pre-SDB-730 environments (staging) still return the raw internal values,
// so both vocabularies are accepted during the rollout window. Drop the raw values
// once dev + staging are both on SDB-730.
export const POLLING_STATUS = {
  // Continue polling
  PROCESSING: 'PROCESSING',
  PENDING: 'PENDING',
  // cqrs SDB-727 renames FABRIC_UPDATED -> COMMAND_PROCESSED (commands can now be
  // processed by processors other than Fabric).
  FABRIC_UPDATED: 'FABRIC_UPDATED',
  COMMAND_PROCESSED: 'COMMAND_PROCESSED',

  // Stop polling - Success
  COMPLETED: 'COMPLETED',
  READ_STORE_UPDATED: 'READ_STORE_UPDATED',

  // Stop polling - Failure
  FAILED: 'FAILED',
  // cqrs SDB-727 renames ERROR_FABRIC -> ERROR_PROCESSOR (see note above).
  ERROR_FABRIC: 'ERROR_FABRIC',
  ERROR_PROCESSOR: 'ERROR_PROCESSOR',
  ERROR_SERVICE: 'ERROR_SERVICE',
  ERROR_BUS: 'ERROR_BUS',
} as const;

export type PollingStatus = typeof POLLING_STATUS[keyof typeof POLLING_STATUS];
